import { render, staticRenderFns } from "./FormControlEmailMessageAttachments.vue?vue&type=template&id=50bef3eb&scoped=true"
import script from "./FormControlEmailMessageAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlEmailMessageAttachments.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlEmailMessageAttachments.vue?vue&type=style&index=0&id=50bef3eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bef3eb",
  null
  
)

export default component.exports